import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {useStyles} from './OsIconsListStyles';
import WindowsIcon from '../UI/svg/apps/Windows';
import AndroidIcon from '../UI/svg/apps/Android';
import AppleIcon from '../UI/svg/apps/Apple';
import IosIcon from '../UI/svg/apps/Ios';
import FireTvIcon from '../UI/svg/apps/FireTv';
import AndroidTvIcon from '../UI/svg/apps/AndroidTv';
//import TvosIcon from '../UI/svg/apps/Tvos';
//import ChromeIcon from '../UI/svg/apps/Chrome';
//import SafariIcon from '../UI/svg/apps/Safari';
//import EdgeIcon from '../UI/svg/apps/Edge';
//import OperaIcon from '../UI/svg/apps/Opera';
//import FirefoxIcon from '../UI/svg/apps/Firefox';
//import BraveIcon from '../UI/svg/apps/Brave';

const OS_ICONS = [
	{id: 'windows', Icon: WindowsIcon},
	{id: 'android', Icon: AndroidIcon},
	{id: 'apple', Icon: AppleIcon},
	{id: 'ios', Icon: IosIcon},
	{id: 'firetv', Icon: FireTvIcon},
	{id: 'androidtv', Icon: AndroidTvIcon},
	//{id: 'tvos', Icon: TvosIcon},
	//{id: 'chrome', Icon: ChromeIcon},
	//{ id: 'safari', Icon: SafariIcon },
	//{id: 'edge', Icon: EdgeIcon},
	//{ id: 'opera', Icon: OperaIcon },
	//{id: 'firefox', Icon: FirefoxIcon},
	//{id: 'brave', Icon: BraveIcon},
];

function OsIconsList({active}) {
	const classes = useStyles();
	return (
		<span className={clsx(classes.iconsList, {[classes.active]: active})}>
			{OS_ICONS.map(({id, Icon}) => (
				<span key={id} className={classes.icon}>
					<Icon/>
				</span>
			))}
		</span>
	);
}

OsIconsList.propTypes = {
	active: PropTypes.bool,
};

export default OsIconsList;